/***
* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work Copyright 2026 Baker Hughes Company.  All rights reserved.

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

***/
import '@backstage/cli/asset-types';

import { createRoot } from 'react-dom/client';
import App from './App';

createRoot(document.getElementById('root')!).render(<App />);
